import React from 'react'
import Popup from "./Popup";
import SearchTable from "./SearchTable"

// ExecuteScriptPopupButton Component
export default class SearchPopupButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible : false
            , output:""
            , scrollChecked:true
            , message:""
            , startime:0
            , elapsedSeconds:0
            //,tableRef:React.createRef()
        }
        this.textLog = React.createRef();
        this.scrollCheckBox = React.createRef();
    }    
    
    componentDidMount(prevProps) {
        //console.log("start");

    }
        
    // render
    render() {



        return(true) ? (
            <span className="search-popup">
                <button 
                    onClick={this.openPopup.bind(this)}
                    hidden={this.props.hidden}
                    disabled={this.props.disabled}
                    className={this.props.className}
                    >
                        {this.props.buttonLabel}
                </button>
                <Popup className="execute-popup" trigger={ this.state.visible }  >
  
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div>  

                    <div className="align-left">
                        <h3>{this.props.screenLabel}</h3>
                        scroll 
                        <input id="myCheckbox" ref={this.scrollCheckBox} type="checkbox" defaultChecked={true} 
                                onChange = {this.handleChange.bind(this) }></input> 
                                elapsed: {this.state.elapsedSeconds} seconds
                        <br></br>
                        {this.state.message}
                        <br></br>
                        <textarea ref={this.textLog} defaultValue={this.state.output}>
                        </textarea><br></br>
                        <span>
                            Please be patient...  Wait till you see "*** done ***"
                        </span>
                        </div>
                </Popup>
            </span>
        ) :"";
    }
    openPopup(){
        this.setState({
            visible:true,
            startime:new Date().getTime()
        }); 
        this.setState({
            "output":""
//            ,"message":"Please Wait.."
        })
        fetch(this.props.securityObject.httpServer+this.props.url+"&sessionId="+this.props.securityObject.userSessionId)
        .then(response => {
          const reader = response.body.getReader();
      
          const read = async () => {
            const { done, value } = await reader.read();
            if (done){
                this.setState({
                    message:""
                })
                return;
            }
      
            const textDecoder = new TextDecoder();
            this.setState(
                {
                    "output":this.state.output+textDecoder.decode(value),
                    elapsedSeconds:(new Date().getTime()-this.state.startime)/1000
                }
            );
            if(this.state.scrollChecked){
                try{
                    this.textLog.current.scrollTop = this.textLog.current.scrollHeight;
                } catch(ex){}
            }
            read(); // Read the next chunk
          };
      
          read();
        });        
    }
    closePopup(){
        if(this.props.onClose){
            this.props.onClose();
        }
        this.setState({
            visible:false
        });  
    }
    handleChange(e) {
        this.setState({
            scrollChecked:e.target.checked
        })
     }
}

